import { connect } from 'react-redux'
import { withMe } from 'pobble-components/dist/pobble-user'
import Avatar from './avatar'
import {
  getUser,
  getUserAvatar,
  getUploadAvatarRequest,
  getRemoveAvatarRequest
} from '../../../../stores/user/user.selectors'
import {
  uploadAvatar,
  removeAvatar
} from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const user = getUser(state)
  const userAvatar = getUserAvatar(state)
  const uploadAvatarRequest = getUploadAvatarRequest(state)
  const removeAvatarRequest = getRemoveAvatarRequest(state)
  return {
    id: user.id,
    pending: uploadAvatarRequest.pending || removeAvatarRequest.pending,
    url: !userAvatar ? null : userAvatar.url,
    name: user.full_name,
    avatar: userAvatar
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  onRemove: id =>
    dispatch(removeAvatar(id))
      .then(ownProps.refetchMe)
      .catch(errorHandler),
  onChange: files =>
    dispatch(uploadAvatar(stateProps.id, files[0]))
      .then(ownProps.refetchMe)
      .catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(Avatar)
)
